<template>
  <div
    ref="rootRef"
    data-glass="glow"
    class="raw-glass rounded-full fixed bottom-[--raw-collapsed-offset] right-[--raw-edge-space] z-10 flex flex-col md:bottom-[--raw-edge-space] md:flex-row"
  >
    <button
      type="button"
      class="rounded-full flex h-36 w-36 items-center justify-center"
      :aria-label="i18n(translations.zoomInLabel)"
      @click="$emit('zoom-in')"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M1.105 6.541a.5.5 0 0 1-.272-.076A.54.54 0 0 1 .565 6q-.003-.149.068-.272a.6.6 0 0 1 .204-.195.5.5 0 0 1 .268-.072l9.795.002a.54.54 0 0 1 .536.536.46.46 0 0 1-.077.272.54.54 0 0 1-.195.196.46.46 0 0 1-.268.072zm4.356-5.436a.5.5 0 0 1 .073-.268.6.6 0 0 1 .19-.2.5.5 0 0 1 .277-.072.54.54 0 0 1 .463.268.5.5 0 0 1 .077.273l-.001 9.79a.46.46 0 0 1-.072.268.56.56 0 0 1-.2.2.46.46 0 0 1-.268.072.54.54 0 0 1-.536-.536z"
        />
      </svg>
    </button>

    <button
      type="button"
      class="rounded-full flex h-36 w-36 items-center justify-center"
      :aria-label="i18n(translations.zoomOutLabel)"
      @click="$emit('zoom-out')"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M1.105 6.541a.5.5 0 0 1-.272-.076A.54.54 0 0 1 .565 6q-.003-.149.068-.272a.6.6 0 0 1 .204-.195.5.5 0 0 1 .268-.072l9.795.002a.54.54 0 0 1 .536.536.46.46 0 0 1-.077.272.54.54 0 0 1-.195.196.46.46 0 0 1-.268.072z"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '~/scopes/campaign/components/MapZoomControl.translations'
import { useElementHeightVar } from '~/scopes/campaign/composables/useElementHeightVar'

defineEmits<{
  'zoom-in': []
  'zoom-out': []
}>()

const i18n = useI18n()

// Publish the control's live height so the right-side ResponsiveModal can cap
// its max-height one gapper above us (same pattern as the header).
const rootRef = ref<HTMLElement | null>(null)
useElementHeightVar(rootRef, '--raw-zoom-control-height')
</script>

<style scoped>
button {
  transition: background-color var(--raw-out-quart);
  --active: color-mix(in oklab, white, transparent);

  @media (hover: hover) {
    &:hover {
      background-color: var(--active);
    }
  }

  &:active {
    background-color: var(--active);
  }
}
</style>
